import { useEffect, useRef } from 'react';
import { logout } from './auth';

export const useConfirmBackLogout = (
  navigate,
  options = {}
) => {
  const {
    enabled = true,
    message = 'この画面を離れるとログアウトされます。よろしいですか？',
  } = options;

  const handlingRef = useRef(false);

  useEffect(() => {
    if (!enabled) return;

    const push = () => {
      window.history.pushState(null, '', window.location.href);
    };

    const handlePopState = () => {
      if (handlingRef.current) return;
      handlingRef.current = true;

      const ok = window.confirm(message);

      if (ok) {
        // はい → 本当に戻る＝ログアウト
        logout(navigate);
      } else {
        // いいえ → 戻るを完全に打ち消す
        push();
        handlingRef.current = false;
      }
    };

    // 初期ガード（これで常に1枚壁がある）
    push();
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [enabled, message, navigate]);
};